import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function RecruitmentRequestsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="77"
      viewBox="0 0 80 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_4617)">
        <path
          d="M54.3806 59.4562H25.3776V71.0574H54.3806V59.4562Z"
          fill="#EAEEF9"
        />
        <path
          d="M75.6496 61.6314H4.35045C1.93353 61.6314 0 59.6979 0 57.281V4.35045C0 1.93353 1.93353 0 4.35045 0H75.6496C78.0665 0 80 1.93353 80 4.35045V57.281C80 59.6979 77.8248 61.6314 75.6496 61.6314Z"
          fill="#EAEEF9"
        />
        <path
          d="M66.4653 76.3746H13.5348C12.0846 76.3746 10.8762 75.1661 10.8762 73.716C10.8762 72.2658 12.0846 71.0574 13.5348 71.0574H66.4653C67.9154 71.0574 69.1239 72.2658 69.1239 73.716C68.8822 75.1661 67.9154 76.3746 66.4653 76.3746Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.2659 56.3142H7.73413C6.52567 56.3142 5.5589 55.3475 5.5589 54.139V7.73419C5.5589 6.52573 6.52567 5.55896 7.73413 5.55896H72.2659C73.4743 5.55896 74.4411 6.52573 74.4411 7.73419V54.139C74.4411 55.3475 73.4743 56.3142 72.2659 56.3142Z"
          fill="white"
        />
        <path
          d="M40.3625 30.2114H8.45921C7.97582 30.2114 7.73413 30.4531 7.73413 30.9365C7.73413 31.4199 7.97582 31.6616 8.45921 31.6616H40.6042C40.3625 31.1782 40.3625 30.6948 40.3625 30.2114Z"
          fill="#00C4B3"
        />
        <path
          d="M39.8791 54.3806C39.3957 54.3806 39.1541 54.139 39.1541 53.6556V7.97581C39.1541 7.49242 39.3957 7.25073 39.8791 7.25073C40.3625 7.25073 40.6042 7.49242 40.6042 7.97581V53.6556C40.6042 54.139 40.3625 54.3806 39.8791 54.3806Z"
          fill="#00C4B3"
        />
        <path
          d="M22.4773 18.1268C17.6435 18.1268 13.7764 21.7522 13.0513 26.3444C13.0513 27.0694 13.5347 27.5528 14.0181 27.5528H30.6948C31.4199 27.5528 31.9033 27.0694 31.6616 26.3444C31.1782 21.7522 27.3112 18.1268 22.4773 18.1268Z"
          fill="#00C4B3"
        />
        <path
          d="M29.7281 13.0514C29.7281 17.1602 26.5861 20.3022 22.4773 20.3022C18.3686 20.3022 15.2266 17.1602 15.2266 13.0514C15.2266 8.94265 18.3686 5.80066 22.4773 5.80066C26.5861 5.80066 29.7281 8.94265 29.7281 13.0514Z"
          fill="white"
        />
        <path
          d="M27.5529 13.0514C27.5529 15.9517 25.3776 18.1269 22.4773 18.1269C19.577 18.1269 17.4018 15.9517 17.4018 13.0514C17.4018 10.1511 19.577 7.97583 22.4773 7.97583C25.3776 7.97583 27.5529 10.1511 27.5529 13.0514Z"
          fill="#00C4B3"
        />
        <path
          d="M22.4773 43.9879C17.6435 43.9879 13.7764 47.6133 13.0513 52.2054C13.0513 52.9305 13.5347 53.4139 14.0181 53.4139H30.6948C31.4199 53.4139 31.9033 52.9305 31.6616 52.2054C31.1782 47.6133 27.3112 43.9879 22.4773 43.9879Z"
          fill="#00416B"
        />
        <path
          d="M29.7281 38.9124C29.7281 43.0211 26.5861 46.1631 22.4773 46.1631C18.3686 46.1631 15.2266 43.0211 15.2266 38.9124C15.2266 34.8036 18.3686 31.6616 22.4773 31.6616C26.5861 31.6616 29.7281 34.8036 29.7281 38.9124Z"
          fill="white"
        />
        <path
          d="M27.5529 38.9124C27.5529 41.8127 25.3776 43.988 22.4773 43.988C19.577 43.988 17.4018 41.8127 17.4018 38.9124C17.4018 36.0121 19.577 33.8369 22.4773 33.8369C25.3776 33.8369 27.5529 36.0121 27.5529 38.9124Z"
          fill="#00416B"
        />
        <path
          d="M41.3293 27.0694L76.858 11.1178C77.5831 10.6344 78.5499 11.6012 78.3082 12.3262L71.0574 41.571C70.8157 42.296 70.0907 42.5377 69.6073 42.296L41.3293 29.003C40.6043 28.5196 40.6043 27.3111 41.3293 27.0694Z"
          fill="#00C4B3"
        />
        <path
          d="M60.9064 33.5952C59.4562 35.287 60.1813 37.9457 62.1148 38.9124L63.0816 39.3958L46.1631 31.42C48.8218 32.6284 52.2054 32.3867 54.6224 30.4532L76.6163 12.8097C76.858 12.568 77.0997 12.8097 76.858 13.0514L60.9064 33.5952Z"
          fill="#00416B"
        />
        <path
          d="M41.3293 42.2961L47.3716 37.7039C47.855 37.4623 47.855 36.7372 47.3716 36.4955L46.4048 36.0121C45.9215 35.7704 45.4381 36.0121 45.1964 36.2538L41.0876 42.0544C40.6042 42.2961 41.0876 42.5378 41.3293 42.2961Z"
          fill="#00416B"
        />
        <path
          d="M45.1964 49.3051L51.2387 44.713C51.7221 44.4713 51.7221 43.7462 51.2387 43.5045L50.2719 43.0211C49.7885 42.7794 49.3051 43.0211 49.0635 43.2628L44.9547 49.0634C44.4713 49.3051 44.9547 49.5468 45.1964 49.3051Z"
          fill="#00416B"
        />
        <path
          d="M56.5559 47.855L62.5982 43.2629C63.0816 43.0212 63.0816 42.2961 62.5982 42.0544L61.6314 41.5711C61.148 41.3294 60.6647 41.5711 60.423 41.8127L56.3142 47.6134C55.8308 47.6134 56.0725 48.0967 56.5559 47.855Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_4617">
          <rect width="80" height="76.3746" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
